import * as Sentry from "@sentry/react";
class FormValidationLogger {
    /**
     * Initializes validation logging for the specified form
     * @param form The HTML form element to monitor
     * @param formName Display name of the form (used in error messages)
     * @param contextData Additional context data to include in the report
     */
    initFormValidationLogging(form, formName = "Form", contextData) {
        const submitButton = form.querySelector('button[type="submit"]');
        submitButton?.addEventListener('click', () => {
            setTimeout(() => {
                if (!form.checkValidity()) {
                    this.logValidationErrorsToSentry(form, formName, contextData);
                }
            }, 0);
        });
    }
    /**
     * Logs validation errors to Sentry
     */
    logValidationErrorsToSentry(form, formName, contextData) {
        const formElements = Array.from(form.elements);
        const invalidFields = {};
        const formData = this.getFormData(form);
        formElements.forEach(element => {
            if (element.validity && !element.validity.valid) {
                const fieldName = element.name || element.id || 'unknownField';
                invalidFields[fieldName] = element.validationMessage;
            }
        });
        if (Object.keys(invalidFields).length > 0) {
            Sentry.withScope(scope => {
                scope.setLevel('warning');
                scope.setContext('Form Data', formData);
                scope.setContext('Invalid Fields', invalidFields);
                if (contextData) {
                    scope.setContext('Additional Context', contextData);
                }
                scope.setTag('error_type', 'form_validation');
                Sentry.captureMessage(`${formName} submission blocked by HTML5 validation`);
            });
        }
    }
    /**
     * Collects form data to include in the Sentry report
     */
    getFormData(form) {
        const formData = new FormData(form);
        const data = {};
        formData.forEach((value, key) => {
            data[key] = value.toString();
        });
        return data;
    }
}
export default new FormValidationLogger();
